import { Component, inject, Input, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'details-action-buttons',
  standalone: true,
  imports: [
    IonicModule
  ],
  templateUrl: './iframe.component.html',
  styleUrl: './iframe.component.scss',
})

export class IframeComponent {
    @Input("title") title;
    @Input("url") url;

    private modalController = inject(ModalController);
    private sanitizer = inject(DomSanitizer);
    public iframeSrc: any;
    public isFullScreen = signal(false);

    ngOnInit(){
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

    dismissModal(){
        this.modalController.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });
    }

    async goToFullScreen(){
        const modal = await this.modalController.getTop();
        modal?.style?.setProperty('--width', '100%');
        modal?.style?.setProperty('--height', '100%');
        modal?.style?.setProperty('--border-radius', '0');
        this.isFullScreen.set(true);
    }

}